// import React from 'react';
import { staticViewsActionTypes, staticViewsActionsInterfaces } from '.';
import { mySubjectsActionTypes } from './mySubjects';
import { subjectsCardsActionTypes } from './subjectsCards';
import { studentsActionTypes } from './students';
import TemplateMaker from '../templates';
import { RESET_REDUCERS } from '../auth/types';

// info: z powodu circular dependency nazwy widoków statycznych zostały zmapowane ręcznie
const staticTabsList: StaticView[] = ['MySubjects', 'SubjectsCards', 'Students'];

export const initState: StaticViewsState = staticTabsList.reduce(
  (acc, tab) => ({
    ...acc,
    [tab]: {
      ...TemplateMaker.table(),
    },
  }),
  {} as StaticViewsState,
);

export default function staticViewsReducer(
  state: StaticViewsState = initState,
  action: staticViewsActionsInterfaces.ActionTypes,
): StaticViewsState {
  switch (action.type) {
    case staticViewsActionTypes.INIT_FINISH:
      return {
        ...state,
        [action.payload.view]: {
          ...state[action.payload.view],
          initTable: false,
        },
      };
    case mySubjectsActionTypes.GET_DATA_START:
    case studentsActionTypes.GET_DATA_START:
    case subjectsCardsActionTypes.GET_DATA_START:
    case staticViewsActionTypes.SET_LOADING:
      return {
        ...state,
        [action.payload.view]: {
          ...state[action.payload.view],
          loading: true,
          cache: {
            ...state[action.payload.view].cache,
            syncInProgress: true,
            error: false,
          },
        },
      };
    case staticViewsActionTypes.GET_DATA_SUCCESS:
      return {
        ...state,
        [action.payload.view]: {
          ...state[action.payload.view],
          data: action.payload.data.data,
          error: false,
          loading: false,
          totalPage: action.payload.data.totalPages,
          totalRecords: action.payload.data.totalRecords,
          page: action.payload.data.page,
          cache: {
            ...state[action.payload.view].cache,
            syncInProgress: false,
            controlSum: action.payload.data.controlSum ? action.payload.data.controlSum : '',
            duration: action.payload.data.cacheDuration ? action.payload.data.cacheDuration : 0,
          },
        },
      };
    case staticViewsActionTypes.SET_DATA_AFTER_SORT:
      return {
        ...state,
        [action.payload.view]: {
          ...state[action.payload.view],
          data: action.payload.data,
        },
      };
    case staticViewsActionTypes.GET_DATA_NEXT_PAGE_START:
      return {
        ...state,
        [action.payload.view]: {
          ...state[action.payload.view],
          error: false,
          loadingPage: true,
        },
      };
    case staticViewsActionTypes.GET_DATA_NEXT_PAGE_SUCCESS:
      return {
        ...state,
        [action.payload.view]: {
          ...state[action.payload.view],
          data: [...state[action.payload.view].data, ...action.payload.data.data],
          error: false,
          loadingPage: false,
        },
      };
    case staticViewsActionTypes.GET_DATA_NEXT_PAGE_FAIL:
      return {
        ...state,
        [action.payload.view]: {
          ...state[action.payload.view],
          error: true,
          loadingPage: false,
        },
      };
    case staticViewsActionTypes.GET_DATA_FAIL:
      return {
        ...state,
        [action.payload.view]: {
          ...state[action.payload.view],
          error: true,
          loading: false,
          cache: {
            ...state[action.payload.view].cache,
            syncInProgress: false,
            error: true,
          },
        },
      };
    case staticViewsActionTypes.SET_SEARCH:
      return {
        ...state,
        [action.payload.view]: {
          ...state[action.payload.view],
          search: action.payload.search,
        },
      };
    case staticViewsActionTypes.SET_PAGE:
      return {
        ...state,
        [action.payload.view]: {
          ...state[action.payload.view],
          page: action.payload.page,
        },
      };
    case staticViewsActionTypes.SET_ORDER:
      return {
        ...state,
        [action.payload.view]: {
          ...state[action.payload.view],
          sorting: {
            columnName: action.payload.settings.columnName,
            order: action.payload.settings.order,
          },
        },
      };
    case staticViewsActionTypes.SET_SELECTED:
      return {
        ...state,
        [action.payload.view]: {
          ...state[action.payload.view],
          selected: action.payload.selected,
        },
      };
    case staticViewsActionTypes.SET_DETAILS_LOADING:
      return {
        ...state,
        [action.payload.view]: {
          ...state[action.payload.view],
          loadingDetails: !state[action.payload.view].loadingDetails,
        },
      };
    // info - do uzupelnienia typy akcji z kolejnych zakladek
    // case mySubjectsActionTypes.RECORD_GET_DETAILS_START:
    // case studentsActionTypes.RECORD_GET_DETAILS_START:
    case staticViewsActionTypes.RECORD_GET_DETAILS_START:
      return {
        ...state,
        [action.payload.view]: {
          ...state[action.payload.view],
          loadingDetails: true,
          errorDetails: false,
        },
      };
    case staticViewsActionTypes.RECORD_GET_DETAILS_SUCCESS:
      return {
        ...state,
        [action.payload.view]: {
          ...state[action.payload.view],
          loadingDetails: false,
          errorDetails: false,
          data: state[action.payload.view].data.map(row =>
            row.key === action.payload.id ? { ...row, details: action.payload.data } : row,
          ),
        },
      };
    case staticViewsActionTypes.RECORD_GET_DETAILS_FAIL:
      return {
        ...state,
        [action.payload.view]: {
          ...state[action.payload.view],
          loadingDetails: false,
          errorDetails: true,
        },
      };
    // info - do uzupelnienia typy akcji z kolejnych zakladek
    case mySubjectsActionTypes.COLUMNS_GET_CONFIG_START:
    case studentsActionTypes.COLUMNS_GET_CONFIG_START:
    case subjectsCardsActionTypes.COLUMNS_GET_CONFIG_START:
      return {
        ...state,
        [action.payload.view]: {
          ...state[action.payload.view],
          loading: true,
        },
      };
    case staticViewsActionTypes.COLUMNS_GET_CONFIG_SUCCESS:
      return {
        ...state,
        [action.payload.view]: {
          ...state[action.payload.view],
          loading: false,
          columns: action.payload.mainColumns,
          marksColumns: action.payload.marksColumns ? action.payload.marksColumns : [],
        },
      };
    case staticViewsActionTypes.COLUMNS_GET_CONFIG_FAIL:
      return {
        ...state,
        [action.payload.view]: {
          ...state[action.payload.view],
          loading: false,
          error: true,
        },
      };
    case staticViewsActionTypes.COLUMNS_CHANGE_SORTING: {
      const columns = [...state[action.payload.view].columns];
      columns.forEach(element => {
        if (element.dataIndex === action.payload.sortingInfo.dataIndex && action.payload.sortingInfo.sortOrder) {
          element.sortOrder = action.payload.sortingInfo.sortOrder;
        } else delete element.sortOrder;
      });
      return {
        ...state,
        [action.payload.view]: {
          ...state[action.payload.view],
          columns: columns,
        },
      };
    }
    case staticViewsActionTypes.COLUMNS_SAVE_USER_SETUP_SUCCESS:
      return {
        ...state,
        [action.payload.view]: {
          ...state[action.payload.view],
          userColumnsSetup: {
            ...state[action.payload.view].userColumnsSetup,
            main: action.payload.data
              .map(column => (column.inMain ? column.dataIndex : null))
              .filter((column): column is string => !!column),
            details: action.payload.data
              .map(column => (column.inDetails ? column.dataIndex : null))
              .filter((column): column is string => !!column),
          },
        },
      };
    case staticViewsActionTypes.FILTERS_OPEN_CATEGORY:
      return {
        ...state,
        [action.payload.view]: {
          ...state[action.payload.view],
          filters: {
            ...state[action.payload.view].filters,
            allFilters: state[action.payload.view].filters.allFilters.map((filter: FilterData) =>
              action.payload.filtersGroups.find(filterGroup => filterGroup === filter.name)
                ? { ...filter, active: true }
                : { ...filter, active: false, selected: [], selectedValues: [] },
            ),
          },
        },
      };
    case staticViewsActionTypes.FILTERS_CLOSE_CATEGORY:
      return {
        ...state,
        [action.payload.view]: {
          ...state[action.payload.view],
          filters: {
            ...state[action.payload.view].filters,
            allFilters: state[action.payload.view].filters.allFilters.map(filter =>
              filter.name === action.payload.filter
                ? {
                    ...filter,
                    active: false,
                    selected: [],
                    selectedValues: [],
                  }
                : filter,
            ),
          },
        },
      };
    case staticViewsActionTypes.FILTERS_SELECT_VALUES:
      return {
        ...state,
        [action.payload.view]: {
          ...state[action.payload.view],
          filters: {
            ...state[action.payload.view].filters,
            allFilters: state[action.payload.view].filters.allFilters.map(filter =>
              filter.name === action.payload.filters.filterGroupName
                ? {
                    ...filter,
                    selected: action.payload.filters.filterValues,
                    selectedValues: filter.values
                      .map(singleValue =>
                        action.payload.filters.filterValues.includes(singleValue.value) ? singleValue.nazwa : null,
                      )
                      .filter(singleValue => singleValue !== null),
                  }
                : filter,
            ),
          },
        },
      };
    case staticViewsActionTypes.FILTERS_GET_CONFIG_SUCCESS:
      return {
        ...state,
        [action.payload.view]: {
          ...state[action.payload.view],
          filters: {
            ...state[action.payload.view].filters,
            loading: false,
            error: false,
            allFilters: action.payload.data.map(filter => ({
              ...filter,
              active: filter.isDefault,
              error: false,
              loading: false,
              selected: filter.defaultValue ? [filter.defaultValue] : [],
              selectedValues: [],
              values: filter.values ? filter.values : [],
            })),
          },
        },
      };
    case staticViewsActionTypes.FILTERS_GET_CONFIG_FAIL:
      return {
        ...state,
        [action.payload.view]: {
          ...state[action.payload.view],
          filters: {
            ...state[action.payload.view].filters,
            loading: false,
            error: true,
          },
        },
      };
    case mySubjectsActionTypes.FILTERS_REFRESH_VALUES_START:
    case studentsActionTypes.FILTERS_REFRESH_VALUES_START:
      return {
        ...state,
        [action.payload.view]: {
          ...state[action.payload.view],
          filters: {
            ...state[action.payload.view].filters,
            loading: true,
            allFilters: state[action.payload.view].filters.allFilters.map(filter => ({
              ...filter,
              loading: filter.active,
              error: false,
            })),
          },
        },
      };
    case staticViewsActionTypes.FILTERS_REFRESH_VALUES_SUCCESS:
      return {
        ...state,
        [action.payload.view]: {
          ...state[action.payload.view],
          filters: {
            ...state[action.payload.view].filters,
            loading: false,
            allFilters: state[action.payload.view].filters.allFilters.map(filter => {
              let newValues: any[] = [];
              Object.keys(action.payload.data).forEach(key => {
                if (key === filter.name) {
                  newValues = action.payload.data[key];
                }
              });
              return {
                ...filter,
                values: newValues,
                loading: false,
                error: false,
              };
            }),
          },
        },
      };
    case staticViewsActionTypes.FILTERS_REFRESH_VALUES_FAIL:
      return {
        ...state,
        [action.payload.view]: {
          ...state[action.payload.view],
          filters: {
            ...state[action.payload.view].filters,
            loading: false,
            error: true,
          },
        },
      };
    case subjectsCardsActionTypes.CHANGE_WKD_FILTER:
      return {
        ...state,
        [action.payload.view]: {
          ...state[action.payload.view],
          page: 1,
          isWKD: action.payload.isWKD,
        },
      };
    // case mySubjectsActionTypes.SYNC_DATA_WITH_CACHE_START:
    case staticViewsActionTypes.SYNC_DATA_WITH_CACHE_START:
      return {
        ...state,
        [action.payload.view]: {
          ...state[action.payload.view],
          cache: {
            ...state[action.payload.view].cache,
            syncInProgress: true,
            error: false,
          },
        },
      };
    case staticViewsActionTypes.SYNC_DATA_WITH_CACHE_SUCCESS:
      return {
        ...state,
        [action.payload.view]: {
          ...state[action.payload.view],
          cache: {
            ...state[action.payload.view].cache,
            syncInProgress: false,
            controlSum: action.payload.data.controlSum,
            isUpToDate: action.payload.data.isUpToDate,
            duration: action.payload.data.duration,
          },
        },
      };
    case staticViewsActionTypes.SYNC_DATA_WITH_CACHE_FAIL:
      return {
        ...state,
        [action.payload.view]: {
          ...state[action.payload.view],
          cache: {
            ...state[action.payload.view].cache,
            syncInProgress: false,
            error: true,
          },
        },
      };
    case RESET_REDUCERS:
      // reset danych stora
      return {
        ...initState,
      };
    default:
      return state;
  }
}
